import { FormControl } from '@angular/forms';
import { Classroom } from '@models/classroom';
import { SchoolLicense } from '@models/license/school-license';
import { IPrintableReportHeading } from '@models/report-print-heading';
import { Topic } from '@models/topic';
import { BrandedReportsHelpers } from './branded-reports-helpers';


export namespace BrandedReportsPrintHelpers {

  export function getClassOverTimePrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
  ): IPrintableReportHeading[] {
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      }
    ];
  }

  export function getClassSkillsHeatmapAndSpreadPrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    activityIdControl: FormControl,
    topics: Topic[],
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);
    const selectedTopic = activityIdControl.value;
    const matchingTopic = BrandedReportsHelpers.findTopicByKey(topics, selectedTopic);

    return [
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },
      {
        label: 'Test',
        value: matchingTopic?.topicName ?? ''
      },
    ];
  }

  export function getIndividualStudentPrintHeaders(
    reportType: string,
    classroomIdControl: FormControl,
    classrooms: Classroom[],
    productSkuIdControl: FormControl,
    schoolLicenses: SchoolLicense[],
    studentName: string,
  ): IPrintableReportHeading[] {
    const selectedClassId = classroomIdControl.value;
    const matchingClass = BrandedReportsHelpers.findClassroomById(classrooms, selectedClassId);
    const selectedSku = productSkuIdControl.value;
    const matchingProduct = BrandedReportsHelpers.findProductById(schoolLicenses, selectedSku);

    return [
      {
        label: 'Report',
        value: reportType ?? '',
      },
      {
        label: 'Class',
        value: matchingClass?.name ?? ''
      },
      {
        label: 'Student',
        value: studentName ?? ''
      },
      {
        label: 'Product',
        value: matchingProduct?.description ?? ''
      },

    ];
  }
}
